import React from "react";
import "./DashboardView.scss";

// components
import DashboardSideBar from "../../components/template/dashboardSideBar/DashboardSideBar";

const DashboardView = (props) => {
  const { children } = props;
  
  return (
    <main className='dashboard' >
      <DashboardSideBar />
      <div className="main">{children}</div>
    </main>
  );
};

export default DashboardView;
